export function IconCircle({
  children,
  className = " w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border border-white/40 backdrop-blur-[20px] bg-white/10",
}: Readonly<{
  children: React.ReactNode;
  className?: string;
}>) {
  return <div className={className}>{children}</div>;
}
